import React, { useContext, useEffect, useState, Fragment, useMemo } from 'react';
import ContentBoardStyled from '../../components/ContentBoardStyled';
import ItemLinkStyled from '../../components/ItemLinkStyled';
import NoItemsInList from '../../components/NoItemsInList';
import { ControlBarContext } from '../ControlBarContext';
import SearchHeader from '../../components/SearchHeader';
import Scrollable from '../../components/Scrollable';
import TitleLine from '../../components/TitleLine';
import VehicleListItem from './ui/VehicleListItem';
import useVehicles from '../../api/useVehicles';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/Loader';

const VehicleListPage = ({ getBreadCrumbs }) => {
  const { setBreadCrumbs } = useContext(ControlBarContext);
  const [searchInput, setSearchInput] = useState('');
  const [options, setOptions] = useState(null);
  const location = useLocation();
  const { data, isLoading, isLoadingMore, setSize } = useVehicles(searchInput, 20, options);

  useEffect(() => {
    const query = new URLSearchParams(location?.search);
    const hmsId = query.get('hmsId');
    const source = query.get('source');
    const status = query.get('status');
    const reasons = query.get('reasons');
    const duration = query.get('duration');
    if (hmsId && duration) setOptions({ hmsId, status, duration, source, reasons });
  }, [location]);

  const shownItems = useMemo(() => {
    const shownItems =
      data && data[0]?.items ? [].concat(...data?.map((data) => data?.items?.flat()).flat()) : [];
    console.log(
      'vehicles : ',
      shownItems.reduce((vehicles, i) => vehicles + (i?.vehicles?.length || 0), 0)
    );
    return shownItems;
  }, [data]);

  const inputHandler = (value) => setSearchInput(value);

  const handleLoadMore = () => {
    if (!isLoading && !isLoadingMore)
      setSize((size) => {
        return Number(size) + 1;
      });
  };

  const isLabelShown = (dealership) =>
    !shownItems
      .map((i) => i.dealership)
      .filter((i) => i.hmsId === dealership.hmsId)
      .indexOf(dealership);

  useEffect(() => setBreadCrumbs(getBreadCrumbs()), [setBreadCrumbs, getBreadCrumbs]);

  return (
    <ContentBoardStyled>
      <SearchHeader
        userInput={searchInput}
        placeholder='Search by VIN, make, model, stock'
        onInputHandler={(event) => inputHandler(event.target.value)}
        onClearHandler={() => inputHandler('')}
      />
      <Scrollable isLoading={isLoading || isLoadingMore} bottomReached={handleLoadMore}>
        {!!shownItems?.length ? (
          shownItems?.map(({ vehicles, dealership }, dealershipIndex) => (
            <Fragment key={dealershipIndex}>
              <TitleLine title={dealership?.name} hidden={!isLabelShown(dealership)} />
              {vehicles &&
                vehicles.length &&
                vehicles.map((vehicle, vehicleIndex) => {
                  return (
                    <ItemLinkStyled
                      to={`/dealers/${dealership.hmsId}/vehicles/${vehicle.vin}`}
                      key={vehicleIndex}
                    >
                      <VehicleListItem data={vehicle} source={options?.source} />
                    </ItemLinkStyled>
                  );
                })}
            </Fragment>
          ))
        ) : (
          <NoItemsInList>
            {!isLoading ? (searchInput ? 'No vehicles found' : 'No vehicles to show') : ''}
          </NoItemsInList>
        )}
      </Scrollable>
      <Loader isLoading={isLoading || isLoadingMore} firstLoad={!shownItems?.length} />
    </ContentBoardStyled>
  );
};

export default VehicleListPage;
